import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { ElevenLabsKeyManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/elevenlabs-keys")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <ElevenLabsKeyManagement />
    </RouteGuard>
  ),
});
